import classNames from 'classnames'

import styles from './styles.module.scss'

type Props = {
  children?: React.ReactNode
  height?: string | number
  isPageType?: boolean
  isTransparentBg?: boolean
  colored?: boolean
}
export default function Loading({
  height = 50,
  isPageType = false,
  isTransparentBg = false,
  colored = false,
  children,
}: Props) {
  return (
    <div
      className={classNames(styles.load_area_wrapper, {
        [styles.type_page]: isPageType,
        [styles.type_colored]: colored,
        [styles.type_transparent_bg]: isTransparentBg,
      })}
      style={isPageType ? {} : { height }}
    >
      <span className="place_blind">로딩중</span>
      <div className={styles.load_area}>
        <div className={classNames(styles.dot, styles.dot1)} />
        <div className={classNames(styles.dot, styles.dot2)} />
        <div className={classNames(styles.dot, styles.dot3)} />
        <div className={classNames(styles.dot, styles.dot4)} />
        <div className={classNames(styles.dot, styles.dot5)} />
        <div className={classNames(styles.dot, styles.dot6)} />
      </div>
      {children}
    </div>
  )
}
